module.exports = "<div class=\"header-tab navbar-fixed-top\">\r\n  <ul class=\"nav nav-tabs\">\r\n    <li *ngFor=\"let item of items ; let i = index\" [class.disabled]=\"!item.disabled\" [class.active]=\"i == navTabService.active\"\r\n    (click)=\"onTabClicked(item.url, item.key)\" [ngStyle]=\"styles\">\r\n      <label [ngClass]=\"'kyc-text-light'\" class=\"mb-0 kyc-f-18 text-uppercase\" [ngStyle]=\"item.style\">\r\n        {{item.label}}\r\n      </label>\r\n    </li>\r\n  </ul>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/common/nav-tab/nav-tab.template.html
// module id = ./src/app/shared/common/nav-tab/nav-tab.template.html
// module chunks = main